import React from "react"
import { fabric } from "fabric"
import { CANVAS_CONFIG, CANVAS_SIZE } from "./../helpers/base-options"
import debounce from "lodash.debounce"
import $ from "jquery"

const DEBOUNCE_DELAY = 500

/**
 *
 * @param canvasRef
 * @returns {unknown}
 */
const useCanvas = (canvasRef) => {
  const [canvas, setCanvas] = React.useState(null)
  const [isResizing, setResizing] = React.useState(true)
  const isMount = React.useRef(false)

  const rescaleCanvas = () => {
    const { paddingLeft, paddingRight } = window.getComputedStyle(
      document.querySelector(".goBagContainer")
    )
    const totalOffset = parseFloat(paddingLeft) + parseFloat(paddingRight)

    const scaleFactorX = (window.innerWidth - totalOffset) / CANVAS_SIZE
    const scaleFactorY = window.innerHeight / CANVAS_SIZE

    if (scaleFactorX < scaleFactorY && scaleFactorX < 1) {
      const nextWidth = CANVAS_SIZE * scaleFactorX
      const nextHeight = CANVAS_SIZE * scaleFactorX
      canvas.setWidth(nextWidth)
      canvas.setHeight(nextHeight)
      canvas.setZoom(scaleFactorX)
    } else if (scaleFactorX > scaleFactorY && scaleFactorY < 1) {
      // skip resizing by Y
    } else {
      canvas.setWidth(CANVAS_SIZE)
      canvas.setHeight(CANVAS_SIZE)
      canvas.setZoom(1)
    }

    const vh = window.innerHeight * 0.022
    document.body.style.setProperty("--vh", `${vh}px`)
    canvas.calcOffset()
    canvas.renderAll()
  }

  // we need to rescale canvas when canvas ref is mounted
  React.useEffect(() => {
    if (isMount.current === false && canvas) {
      rescaleCanvas()
      setResizing(false)
      isMount.current = true
    }
  }, [canvas])

  React.useEffect(() => {
    if (window && canvas) {
      const onResize = () => {
        setResizing(true)
        $(canvasRef.current).fadeOut("faster", function () {
          rescaleCanvas()
          $(this).fadeIn(() => {
            setResizing(false)
          })
        })
      }
      const debouncedOnResize = debounce(onResize, DEBOUNCE_DELAY)
      window.addEventListener("resize", debouncedOnResize)

      return () => {
        window.removeEventListener("resize", debouncedOnResize)
        debouncedOnResize.cancel()
      }
    }
  }, [canvas])

  /**
   * initialize canvas instance
   */
  React.useLayoutEffect(() => {
    const _canvas = new fabric.Canvas(canvasRef.current, CANVAS_CONFIG)

    setCanvas(_canvas)
  }, [])

  return { canvas, isResizing }
}

export default useCanvas
